import React, { useState, useEffect, useRef } from "react";

const MouseTrail = ({ message = "✨ Follow Me! ✨" }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);
  const containerRef = useRef(null);

  // Handle mouse movement
  useEffect(() => {
    const handleMouseMove = (e) => {
      // Track mouse position within the container
      const rect = containerRef.current.getBoundingClientRect();
      setPosition({
        x: e.clientX - rect.left - 20, // Offset to the left of the cursor
        y: e.clientY - rect.top -10,
      });
    };

    const handleMouseEnter = () => {
      setIsHovering(true); // Mouse has entered the container
    };

    const handleMouseLeave = () => {
      setIsHovering(false); // Mouse has left the container
    };

    const container = containerRef.current;
    if (!container) return;

    container.addEventListener("mousemove", handleMouseMove);
    container.addEventListener("mouseenter", handleMouseEnter);
    container.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      container.removeEventListener("mousemove", handleMouseMove);
      container.removeEventListener("mouseenter", handleMouseEnter);
      container.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="w-full h-full z-10 absolute hidden md:block"
    >
      {isHovering && (
        <span
          style={{
            left: `${position.x}px`,
            top: `${position.y}px`,
          }}
          className="absolute text-white bg-black py-1 px-3 text-sm rounded font-bold transform -translate-x-full -translate-y-1/2 whitespace-nowrap"
        >
          {message}
        </span>
      )}
    </div>
  );
};

export default MouseTrail;
